import { useEffect, useRef, useState, type ReactNode } from 'react';
import { useLocation } from 'react-router';
import { useAuth0 } from '@auth0/auth0-react';
import { useTracking } from '#src/hooks/tracking/TrackingProvider.tsx';
import { ACCOUNT_SETUP_PATH } from '#src/pages/manage/account-setup/AccountSetupPage.tsx';
import { usePermissions } from '../auth.tsx';
import { useSelf } from '../self.ts';

type TrackingRouteWrapperProps = {
  children: ReactNode;
};

export const TrackingRouteWrapper = ({
  children,
}: TrackingRouteWrapperProps) => {
  const location = useLocation();
  const { trackView } = useTracking();
  const { isAuthenticated, isLoading: auth0Loading, user } = useAuth0();
  const trackViewRef = useRef(trackView);
  const [previousPath, setPreviousPath] = useState<string | null>(null);
  const { isImpersonating, integrationPartnerUuid } = usePermissions();
  const { self, loading: selfLoading } = useSelf();

  const loading = auth0Loading || selfLoading;

  useEffect(() => {
    if (
      location.pathname !== previousPath &&
      location.pathname !== ACCOUNT_SETUP_PATH &&
      !loading
    ) {
      setPreviousPath(location.pathname);
      const trackingFunctionProps = {
        eventName: `developer_site_page_displayed`,
        data: {
          path: location.pathname,
          isLoggedIn: isAuthenticated,
          userId: user?.sub || null,
          integrationPartnerId: integrationPartnerUuid || null,
          isImpersonation: Boolean(isImpersonating),
          integrationPartnerName: self?.partner.name || null,
        },
      };
      trackViewRef.current(trackingFunctionProps);
    }
  }, [
    location,
    isAuthenticated,
    user,
    previousPath,
    isImpersonating,
    integrationPartnerUuid,
    self,
    loading,
  ]);

  return children;
};
